import React from "react";
import { Helmet } from "react-helmet-async";
import ContactForm from "../components/form/ContactForm";
import ResponsiveImage from "../components/ResponsiveImage";
import { CONTACT_EMAIL } from "../config/contact";

const Contacts = () => {
  return <main className="rg-page rg-contact-page">
    <Helmet>
      <title>Request a Quote or Sample Edit | Resham Gurung</title>
      <meta name="description" content="Contact Resham Gurung for photo editing quotes, sample edits, and project inquiries." />
      <meta name="robots" content="index, follow" />
    </Helmet>
    <header className="rg-contact-heading rg-container">
      <p className="rg-editorial-overline">LET’S CREATE SOMETHING BEAUTIFUL</p>
      <h1>It starts with a conversation.</h1>
      <p>A single photograph or an entire gallery. Tell me what you have in mind.</p>
      <div className="rg-editorial-signature">Your vision, thoughtfully refined.</div>
    </header>
    <div className="rg-contact-layout rg-container">
      <aside className="rg-contact-aside" aria-label="Contact details">
        <ResponsiveImage className="rg-contact-photo" src="/assets/img/bg/contact.jpg" sizes="(max-width: 768px) calc(100vw - 30px), 420px" alt="Camera and laptop on a creative workspace" />
        <div className="rg-contact-details">
          <p className="rg-editorial-overline">A NOTE AWAY</p>
          <h2>Let’s make it beautiful.</h2>
          <p>Careful, natural photo editing for photographers, studios, and creative businesses.</p>
          <dl>
            <dt>EMAIL</dt>
            <dd><a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a></dd>
            <dt>BASED IN</dt>
            <dd>Kathmandu, Nepal<span>Working with clients around the world.</span></dd>
          </dl>
          <p className="rg-contact-help">Have a reference or a favorite editing style? Share a link with your inquiry so I can get a feel for your vision.</p>
        </div>
      </aside>
      <section className="rg-contact-form-panel" aria-labelledby="contact-form-heading">
        <h2 id="contact-form-heading">Tell me about your project.</h2>
        <ContactForm />
      </section>
    </div>
  </main>;
};
export default Contacts;
